/**
 * Shared labels for the Service screens.
 *
 * This file used to also carry a copy of a server rule about which outcomes
 * were available, because the technician needed to know before submitting.
 * That rule is gone - see the note beside OUTCOMES.
 */

export const STATUS_LABELS: Record<string, string> = {
  COLLECTED: "Collected — awaiting the workshop",
  RECEIVED: "At the workshop — awaiting diagnosis",
  DIAGNOSED: "Diagnosis recorded — awaiting the outcome",
  SERVICED: "OK — returned as it came",
  REPLACED: "Replaced — free or pro-rata",
  REJECTED: "Rejected",
  DELIVERED: "Delivered back",
  CANCELLED: "Cancelled",
};

/**
 * LEGACY. Nothing asks for a warranty status any more - the business decided
 * it is judged manually by the Service Manager and does not belong in the app.
 * Jobs diagnosed before that hold a real value and are still shown it.
 */
export const WARRANTY_LABELS: Record<string, string> = {
  IN_WARRANTY: "In warranty",
  OUT_OF_WARRANTY: "Out of warranty",
  UNKNOWN: "Not established",
};

/**
 * The four outcomes, in the business's own words, with what each one does.
 *
 * The consequence line is not decoration: these four differ in whether stock
 * moves and whether anything is billed, and that is invisible from the name.
 * Somebody choosing FOC is giving away a battery.
 */
export const OUTCOMES: {
  value: string;
  label: string;
  consequence: string;
}[] = [
  {
    value: "OK",
    label: "OK — return their battery",
    consequence:
      "Nothing is billed and no stock moves. Their own battery goes straight to Delivery.",
  },
  {
    value: "FOC",
    label: "FOC — replace free of charge",
    consequence:
      "Bills zero, but ISSUES a new battery — stock is deducted when the bill is raised.",
  },
  {
    value: "PRORATA",
    label: "Pro-rata — replace at a part charge",
    consequence:
      "Issues a new battery AND charges the customer. You enter the amount at the next step.",
  },
  {
    value: "REJECTED",
    label: "Rejected — nothing can be done",
    consequence:
      "Nothing is billed and no stock moves. Their own battery goes straight to Delivery.",
  },
];

/**
 * There is deliberately no outcomeProblem any more.
 *
 * It used to mirror a server rule that refused an outcome contradicting the
 * warranty status or the repairable flag. Both fields are gone, so the outcome
 * is the only statement of what was decided and there is nothing left for it
 * to contradict. The duplicated-rule guard in test/service.test.ts went with
 * it, and a new guard asserts neither copy has crept back.
 */
